import React from 'react'
import { PLL_LINKS } from '../../Config/config'
import { CURRENT_YEAR } from '../../Config/League/league.config'
import { logEvent, getPreviewUrl } from '../../Utils'
import type { EventGQL } from '../../Api'
import { GameLinkOutlined } from './styles'
import { ANALYTICS_TAGS } from '../../Constants/analytics'
type ScheduleActionsProps = {
  event: EventGQL
  section?: string
}

export const GameAction: React.FC<React.PropsWithChildren<ScheduleActionsProps>> = ({
  event,
  section,
}) => {
  const log = (btnText: string) => {
    const analytics = {
      event: ANALYTICS_TAGS.schedule_btn_click,
      params: {
        text: btnText,
        game: event?.slugname,
        gameStatus: event?.eventStatus,
        section: section || 'schedule',
      },
    }
    logEvent(analytics.event, analytics.params)
  }
  const createStatsUrl = (eventId: string) => {
    return `${PLL_LINKS.stats}/games/${CURRENT_YEAR}/${eventId}`
  }
  if (event?.eventStatus === 0) {
    if (event?.league !== 'PLL') return
    return (
      <GameLinkOutlined
        href={getPreviewUrl(event?.slugname)}
        aria-label={`Preview - ${event?.slugname}-${event?.eventStatus}`}
      >
        <button onClick={() => log('Preview')}>Preview</button>
      </GameLinkOutlined>
    )
  } else {
    return (
      <GameLinkOutlined
        href={createStatsUrl(event.slugname)}
        aria-label={`Stats - ${event?.slugname}-${event?.eventStatus}`}
      >
        <button onClick={() => log(event?.eventStatus === 1 ? 'Stats' : 'Recap')}>
          {event?.eventStatus === 1 ? 'Stats' : 'Recap'}
        </button>
      </GameLinkOutlined>
    )
  }
}
